import { createApp } from '@app/adapters/create-app'

import OverviewNavigationDrawer from '@app/application/workflow-overview-navigation/components/overview-navigation-drawer.vue'

window.onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour='left-sidepanel-overview-navigation']")
    .each(function () {
      const {
        allowedFilterValues,
        defaultFilterParamValue,
        highlightedId,
        highlightedType,
        ledgerId,
        userType,
        dependsOnReviewStore,
        workflowId,
        messageBusChannel,
        messageBusLastId,
        ctrlClick,
      } = this.dataset

      createApp(OverviewNavigationDrawer, {
        allowedFilterValues: allowedFilterValues
          ? JSON.parse(allowedFilterValues)
          : undefined,
        defaultFilterParamValue,
        dependsOnReviewStore: dependsOnReviewStore === 'true',
        highlightedId: highlightedId ? parseInt(highlightedId, 10) : null,
        highlightedType: highlightedType,
        ledgerId: ledgerId ? parseInt(ledgerId, 10) : null,
        workflowId: workflowId ? parseInt(workflowId, 10) : null,
        userType,
        messageBusChannel,
        messageBusLastId,
        ctrlClick: ctrlClick !== 'false',
      }).mount(this)
    })
})
